import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';

import { environment } from '@pt/environment';
import {
  Achievement,
  AchievementComponent as PuAchievementComponent,
  AchievementNamePosition,
} from '@hglobal/common';

@Component({
  selector: 'pt-achievement',
  imports: [PuAchievementComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <pu-achievement
      [achievement]="achievement()"
      [isHoverable]="isHoverable()"
      [withName]="withName()"
      [namePosition]="namePosition()"
      [optimizationEnabled]="optimizationEnabled"
    />
  `,
})
export class AchievementComponent {
  isHoverable = input<boolean, unknown>(false, { transform: booleanAttribute });
  withName = input<boolean, unknown>(false, { transform: booleanAttribute });
  achievement = input.required<Achievement>();
  namePosition = input<AchievementNamePosition>('bottom');

  readonly optimizationEnabled = environment.imagesOptimizationEnabled;
}
